import React from 'react';
import './Marquee.css';

const WORDS = ['AI AGENTS', 'SOFTWARE', 'CRM', 'MARKETING', 'DEVOPS', 'AUTOMATION', 'UI / UX', 'SEO', 'ANALYTICS', 'GROWTH', 'SUPPORT'];

function MarqueeTrack() {
  return (
    <div className="marquee-track">
      {WORDS.map((word) => (
        <span className="marquee-item" key={word}>
          {word}
          <span className="marquee-dot" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee">
      <div className="marquee-scroller">
        <MarqueeTrack />
        <MarqueeTrack />
      </div>
    </div>
  );
}
